import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import { Forum as ConversationIcon } from '@mui/icons-material';
import { useAuth } from '../../hooks/useAuth';

/** Said instead of a link the viewer could not follow (no `viewPatients`). */
export const NO_CONVERSATION_ACCESS = "You don't have access to the conversation";

/**
 * PRX-132 — a task made from a Communication Center thread keeps a link back
 * to it. Renders nothing for any other task. Opening the thread needs
 * `viewPatients`; an assignee without it (e.g. an Inventory manager on an
 * Inventory task) is told so rather than handed a link that fails.
 */
export const SourceThreadLink: React.FC<{ sourceThreadId?: string | null }> = ({ sourceThreadId }) => {
  const { customRole, hasCustomPermission } = useAuth();
  if (!sourceThreadId) return null;
  if (customRole && !hasCustomPermission('viewPatients')) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {NO_CONVERSATION_ACCESS}
      </Typography>
    );
  }
  return (
    <Button
      component={RouterLink}
      to={`/communications?thread=${sourceThreadId}`}
      size="small"
      variant="outlined"
      startIcon={<ConversationIcon />}
      sx={{ mb: 2 }}
    >
      Open conversation
    </Button>
  );
};

export default SourceThreadLink;
